export default {
  props: {
    alwaysVisible: Boolean,
  },
  data() {
    return {
      visible: this.alwaysVisible,
      observeVisibility: {
        callback: this.alwaysVisible ? () => {} : this.visibilityChanged,
        once: true,
        throttle: 300,
      },
    }
  },
  methods: {
    visibilityChanged(visible) {
      this.visible = visible
    },
  },
}
